// extracted by mini-css-extract-plugin
export default {"sec_name":"Videos_sec_name__k26Om"};